<template>
    <v-container fluid>
        <v-card>
            <v-card-title>
                <v-row dense align="center">
                    <v-col cols="12" md="5">
                        <div class="text-subtitle-1 font-weight-bold">
                            <v-icon left color="primary">{{ def.icono }}</v-icon>{{ def.titulo }}
                        </div>
                        <div class="text-caption grey--text text--darken-1">{{ def.descripcion }}</div>
                    </v-col>
                    <v-col cols="12" sm="7" md="4">
                        <v-text-field v-model="busqueda" hide-details dense outlined clearable prepend-inner-icon="search" label="Buscar"/>
                    </v-col>
                    <v-col cols="12" sm="5" md="3" class="text-sm-right">
                        <v-btn color="info" small outlined class="mr-2" :loading="cargando" @click="cargar">
                            <v-icon small>refresh</v-icon>
                        </v-btn>
                        <v-btn color="success" small outlined v-if="permisos.crear" @click="nuevo">
                            <v-icon small left>add</v-icon> Nuevo
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text>
                <v-data-table
                    dense
                    :headers="encabezados"
                    :items="filas"
                    :search="busqueda"
                    :loading="cargando"
                    :item-key="def.id"
                    :items-per-page="25"
                    :footer-props="$store.state.footerPropsTable"
                    sort-by="nombre"
                >
                    <template v-slot:[`item.activo`]="{ item }">
                        <v-chip x-small label :color="item.activo ? 'success' : 'grey'" text-color="white">{{ item.activo ? 'Activo' : 'Inactivo' }}</v-chip>
                    </template>
                    <template v-slot:[`item.en_uso`]="{ item }">
                        <span :class="item.en_uso ? '' : 'grey--text'">{{ item.en_uso }}</span>
                    </template>
                    <template v-slot:[`item.enlace_curricula`]="{ item }">
                        <a v-if="item.enlace_curricula" :href="item.enlace_curricula" target="_blank" rel="noopener">Abrir</a>
                    </template>
                    <template v-slot:[`item.fecha_actualizacion`]="{ item }">
                        {{ item.fecha_actualizacion | fechaESPHora }}
                    </template>
                    <template v-slot:[`item.acciones`]="{ item }">
                        <v-btn icon small color="info" v-if="permisos.editar" title="Editar" @click="editar(item)"><v-icon small>edit</v-icon></v-btn>
                        <v-btn icon small color="error" v-if="permisos.eliminar" title="Eliminar" @click="confirmarEliminar(item)"><v-icon small>delete</v-icon></v-btn>
                    </template>
                    <template v-slot:no-data>
                        <v-alert dense type="info" outlined class="text-center mt-3">
                            Aún no hay registros. {{ permisos.crear ? 'Use el botón Nuevo para agregar el primero.' : '' }}
                        </v-alert>
                    </template>
                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- Formulario -->
        <v-dialog v-model="dialogo" max-width="760" persistent scrollable>
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">
                    {{ modelo[def.id] ? 'Editar' : 'Nuevo' }} {{ def.singular }}
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dialogo = false"><v-icon>close</v-icon></v-btn>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form" v-model="valido" @submit.prevent="guardar">
                        <v-row dense>
                            <v-col v-for="campo in def.campos" :key="campo.clave" cols="12" :md="campo.ancho || 6">
                                <v-textarea v-if="campo.tipo === 'textarea'"
                                            v-model="modelo[campo.clave]" :label="campo.etiqueta" :hint="campo.ayuda" persistent-hint
                                            outlined dense rows="3" auto-grow :maxlength="campo.maximo" :counter="campo.maximo"
                                            :rules="reglas(campo)"/>
                                <v-text-field v-else
                                              v-model="modelo[campo.clave]" :label="campo.etiqueta" :hint="campo.ayuda" persistent-hint
                                              outlined dense :type="campo.tipo === 'numero' ? 'number' : 'text'"
                                              :maxlength="campo.maximo" :counter="campo.maximo > 60 ? campo.maximo : undefined"
                                              :placeholder="campo.ejemplo" :rules="reglas(campo)"/>
                            </v-col>
                            <v-col cols="12">
                                <v-switch v-model="modelo.activo" inset hide-details color="success"
                                          :label="modelo.activo ? 'Activo: se ofrece en los formularios' : 'Inactivo: se conserva pero no se ofrece'"/>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions class="px-6 pb-4">
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogo = false">Cancelar</v-btn>
                    <v-btn color="primary" depressed :loading="guardando" @click="guardar">
                        <v-icon small left>save</v-icon> Guardar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogoEliminar" max-width="420">
            <v-card>
                <v-card-title class="text-subtitle-1 font-weight-bold">Eliminar {{ def.singular }}</v-card-title>
                <v-card-text>
                    ¿Eliminar <b>{{ aEliminar ? (aEliminar.nombre || aEliminar.nombre_oficial) : '' }}</b>?
                    Solo se puede eliminar si ningún registro lo usa; si lo usan, desactívelo.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialogoEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" depressed :loading="guardando" @click="eliminar">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import Auth from "@/services/auth";

/**
 * Página genérica de catálogo (sedes, departamentos, catálogo de cursos).
 * La definición de cada uno vive aquí; el API es /catalogos/{tipo}.
 */
const DEFINICIONES = {
    sedes: {
        id: "sede_id", slug: "/administracion/sedes", icono: "location_city",
        titulo: "Sedes", singular: "sede",
        descripcion: "Centros físicos de INFOP. Cada unidad operativa pertenece a una sede.",
        campos: [
            {clave: "nombre", etiqueta: "Nombre", maximo: 150, requerido: true, ejemplo: "Tegucigalpa"},
            {clave: "codigo", etiqueta: "Código", maximo: 20, ejemplo: "TGU"},
            {clave: "ciudad", etiqueta: "Ciudad", maximo: 100},
            {clave: "telefono", etiqueta: "Teléfono", maximo: 30},
            {clave: "direccion", etiqueta: "Dirección", maximo: 250, ancho: 12},
        ],
        columnas: [
            {text: "Nombre", value: "nombre"}, {text: "Código", value: "codigo"}, {text: "Ciudad", value: "ciudad"},
            {text: "Teléfono", value: "telefono"}, {text: "Unidades", value: "en_uso", align: "end"},
        ],
    },
    departamentos: {
        id: "departamento_id", slug: "/administracion/departamentos", icono: "corporate_fare",
        titulo: "Departamentos", singular: "departamento",
        descripcion: "Áreas internas de INFOP. Se eligen en los administradores, las firmas y las unidades operativas.",
        campos: [
            {clave: "nombre", etiqueta: "Nombre", maximo: 150, requerido: true, ejemplo: "Formación a Distancia"},
            {clave: "codigo", etiqueta: "Código", maximo: 20},
            {clave: "descripcion", etiqueta: "Descripción", maximo: 250, ancho: 12},
        ],
        columnas: [
            {text: "Nombre", value: "nombre"}, {text: "Código", value: "codigo"}, {text: "Descripción", value: "descripcion"},
            {text: "En uso", value: "en_uso", align: "end"},
        ],
    },
    cursos: {
        id: "curso_catalogo_id", slug: "/administracion/catalogo_cursos", icono: "menu_book",
        titulo: "Catálogo de cursos", singular: "curso",
        descripcion: "Nombres oficiales de los cursos. En la importación basta con la columna Código Curso: el sistema toma el nombre oficial, y las horas y la currícula si la fila no las trae.",
        campos: [
            {clave: "codigo", etiqueta: "Código INFOP Virtual", maximo: 60, requerido: true, ejemplo: "IV-EXC-001", ancho: 4},
            {clave: "nombre_oficial", etiqueta: "Nombre oficial", maximo: 300, requerido: true, ancho: 8},
            {clave: "programa", etiqueta: "Programa", maximo: 150, ancho: 4},
            {clave: "categoria", etiqueta: "Categoría", maximo: 150, ancho: 4},
            {clave: "tipo_curso", etiqueta: "Tipo de curso", maximo: 80, ancho: 4},
            {clave: "horas", etiqueta: "Horas", tipo: "numero", ancho: 4},
            {clave: "codigo_curricula", etiqueta: "Código de currícula", maximo: 60, ancho: 4},
            {clave: "enlace_curricula", etiqueta: "Enlace de currícula", maximo: 500, tipo: "url", ancho: 4, ejemplo: "https://..."},
            {clave: "descripcion", etiqueta: "Descripción", maximo: 2000, tipo: "textarea", ancho: 12},
        ],
        columnas: [
            {text: "Código", value: "codigo"}, {text: "Nombre oficial", value: "nombre_oficial"}, {text: "Programa", value: "programa"},
            {text: "Categoría", value: "categoria"}, {text: "Tipo", value: "tipo_curso"}, {text: "Horas", value: "horas", align: "end"},
            {text: "Currícula", value: "codigo_curricula"}, {text: "Enlace", value: "enlace_curricula", sortable: false},
            {text: "Actualizado", value: "fecha_actualizacion"}, {text: "Cursos", value: "en_uso", align: "end"},
        ],
    },
};

export default {
    name: "AdministracionCatalogo",
    props: {
        tipo: {type: String, required: true},
    },
    data() {
        return {
            cargando: false,
            guardando: false,
            busqueda: "",
            filas: [],
            permisos: {crear: false, editar: false, eliminar: false},
            dialogo: false,
            dialogoEliminar: false,
            valido: true,
            modelo: {activo: true},
            aEliminar: null,
        }
    },
    computed: {
        def() {
            return DEFINICIONES[this.tipo];
        },
        encabezados() {
            return [
                ...this.def.columnas,
                {text: "Estado", value: "activo", sortable: false},
                {text: "", value: "acciones", sortable: false, align: "end"},
            ];
        },
    },
    watch: {
        tipo() {
            this.filas = [];
            this.busqueda = "";
            this.iniciar();
        },
    },
    methods: {
        reglas(campo) {
            const reglas = [];
            if (campo.requerido) reglas.push(v => (v !== null && v !== undefined && String(v).trim() !== "") || "Campo requerido");
            if (campo.tipo === "url") reglas.push(v => !v || /^https?:\/\/\S+$/i.test(String(v).trim()) || "Debe ser un enlace que empiece con http:// o https://");
            if (campo.tipo === "numero") reglas.push(v => v === null || v === "" || v === undefined || (Number(v) >= 0 && Number.isInteger(Number(v))) || "Número entero");
            return reglas;
        },
        iniciar() {
            Auth.checkPermisos(this.def.slug).then(() => this.cargar());
        },
        cargar() {
            this.cargando = true;
            window.axios.get(`/catalogos/${this.tipo}`).then(response => {
                if (response.data.success) {
                    this.filas = response.data.data.filas;
                    this.permisos = response.data.data.permisos;
                } else {
                    this.$toast.error(response.data.message);
                }
            })
                .catch(() => this.$toast.error("No se pudo cargar el catálogo."))
                .finally(() => {
                    this.cargando = false;
                });
        },
        vacio() {
            const modelo = {activo: true};
            this.def.campos.forEach(c => {
                modelo[c.clave] = null;
            });
            return modelo;
        },
        nuevo() {
            this.modelo = this.vacio();
            this.dialogo = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        editar(fila) {
            this.modelo = {...this.vacio(), ...fila, activo: !!fila.activo};
            this.dialogo = true;
            this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation());
        },
        guardar() {
            if (!this.$refs.form.validate()) return;

            this.guardando = true;
            const datos = {activo: this.modelo.activo ? 1 : 0};
            datos[this.def.id] = this.modelo[this.def.id] || null;
            this.def.campos.forEach(c => {
                const v = this.modelo[c.clave];
                datos[c.clave] = (v === "" || v === undefined) ? null : v;
            });

            window.axios.post(`/catalogos/${this.tipo}/guardar`, datos).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.dialogo = false;
                    this.cargar();
                } else {
                    this.$toast.error(response.data.message, {timeout: 8000});
                }
            })
                .catch(error => {
                    const mensaje = error.response && error.response.data && error.response.data.message;
                    this.$toast.error(mensaje || "No se pudo guardar.", {timeout: 8000});
                })
                .finally(() => {
                    this.guardando = false;
                });
        },
        confirmarEliminar(fila) {
            this.aEliminar = fila;
            this.dialogoEliminar = true;
        },
        eliminar() {
            this.guardando = true;
            const datos = {};
            datos[this.def.id] = this.aEliminar[this.def.id];

            window.axios.post(`/catalogos/${this.tipo}/eliminar`, datos).then(response => {
                if (response.data.success) {
                    this.$toast.success(response.data.message);
                    this.dialogoEliminar = false;
                    this.cargar();
                } else {
                    this.$toast.error(response.data.message, {timeout: 10000});
                }
            })
                .catch(error => {
                    const mensaje = error.response && error.response.data && error.response.data.message;
                    this.$toast.error(mensaje || "No se pudo eliminar.", {timeout: 10000});
                })
                .finally(() => {
                    this.guardando = false;
                });
        },
    },
    created() {
        this.iniciar();
    },
}
</script>
